<template>
  <Proedit :value="value" compact @changer="$emit('changer', $event)" />
</template>

<script>
import Proedit from './Proedit.vue'

export default {
  components: { Proedit },
  props: {
    value: { type: String, default: '' }
  }
}
</script>
